



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import shrinkableMenu from "../components/shrinkable-menu/shrinkable-menu.vue";
import tagsPageOpened from "../components/tags-page-opened.vue";
import breadcrumbNav from "../components/breadcrumb-nav.vue";
import fullScreen from "../components/fullscreen.vue";
import lockScreen from "../components/lockscreen/lockscreen.vue";
import notice from "../components/notices/notice.vue";
import extraMenu from "../components/extraMenu.vue";
import util from "../lib/util";
import copyfooter from "../components/Footer.vue";
import LanguageList from "../components/language-list.vue";
import AbpBase from "../lib/abpbase";
import systemInfo from "../lib/infoConfig";
import ajax from '../lib/ajax';
import qs from 'qs'
import Cookies from 'js-cookie'
// import { appRouters} from '../router/router'
import axios from 'axios'

const appid = "wx003757ee144cae06";
const agentid = "1000052";
const redirect_uri = encodeURIComponent("http://qy.chinapsp.cn:8884");
const state = 2
const apiKey = '6dc99789-2448-4f11-9bfa-e6600366c6cb'
const siteId = '2139'
const channelId = '2140'

@Component({
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
    extraMenu
  }
})
export default class Main extends AbpBase {
  shrink: boolean = false;
  isIframe: boolean = false;
  systemInfo = systemInfo;
  // avatar: string = ''
  hasDocument: boolean = false
  showDocument: boolean = false
  document: any = {}
  
  get userName() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  get avatar() {
    return this.$store.state.session.user ? this.$store.state.session.user.avatar : ''
  }
  isFullScreen: boolean = false;
  messageCount: string = "0";
  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr;
  }
  get menuList() {
    return this.$store.state.app.menuList;
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>;
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }
  get lang() {
    return this.$store.state.app.lang;
  }
  get avatorPath() {
    return localStorage.avatorImgPath;
  }
  get cachePage() {
    return this.$store.state.app.cachePage;
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme;
  }
  get mesCount() {
    return this.$store.state.app.messageCount;
  }
  get isMobile() {
    const reg = /Android|webOS|iPhone|iPod|BlackBerry|SymbianOS|Windows Phone/i
    return reg.test(navigator.userAgent)
  }
  testCode() {
    util.abp.auth.clearToken()
    const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=test#wechat_redirect`;
    window.location.href = loginUrl;
    // this.refreshWxConfig()
  }
  
  async init() {
    let pathArr = util.setCurrentPath(this, this.$route.name as string);
    this.$store.commit("app/updateMenulist");
    //映射菜单
    if(util.abp.session.userId){//判断是否已登录
      let rep:any =await ajax.get('/api/services/app/AbpMenu/GetAllMenusByRoles', {
        params: {
          roles: this.$store.state.session.roleIds
        },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })
    if(rep.data.success){
      this.$store.state.app['menuList'] = util.abp.auth.new_menu
      this.$store.state.app['menuData'] = rep.data.result.items
      
    }
    }
    if (pathArr.length >= 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    let messageCount = 3;
    this.messageCount = messageCount.toString();
    this.checkTag(this.$route.name);
  }
  toggleClick() {
    this.shrink = !this.shrink;
  }
  handleClickUserDropdown(name: string) {
    if (name === "modifyPwd") {
      this.$router.push({ name: "forgetPwd" })
      // this.$Modal.confirm({
      //   title: '修改密码',
      //   content: '<p>修改密码需要退出当前登录，是否继续修改？</p>',
      //   okText: '继续修改',
      //   cancelText: '取消',
      //   onOk: () => {
      //     this.$store.commit("app/logout", this)
      //     util.abp.auth.clearToken()
      //     setTimeout(() => {
      //       this.$router.push({ name: "forgetPwd" })
      //     }, 1000)
      //   },
      //   onCancel: () => {}
      // })
    } else if (name === "ownSpace") {
      util.openNewPage(this, "ownspace_index", null, null);
      this.$router.push({
        name: "userProfile"
      });
    } else if (name === "loginout") {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      location.reload();
      Cookies.remove('readed')
    }
  }
  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true;
      } else {
        return false;
      }
    });
    if (!openpageHasTag) {
      util.openNewPage(
        this,
        name as string,
        this.$route.params || {},
        this.$route.query || {}
      );
    }
  }
  handleSubmenuChange(val: string) {
    
  }
  beforePush(name: string) {
    if (name === "accesstest_index") {
      return false;
    } else {
      return true;
    }
  }
  fullscreenChange(isFullScreen: boolean) {
    
  }
  @Watch("$route")
  routeChange(to: any) {
    this.$store.commit("app/setCurrentPageName", to.name);
    let pathArr = util.setCurrentPath(this, to.name);
    if (pathArr.length > 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    this.checkTag(to.name);
    localStorage.currentPageName = to.name;
    if (to.name.indexOf("(i)") !== -1) {
      this.isIframe = true;
    } else {
      this.isIframe = false;
    }
  }
  @Watch("lang")
  langChange() {
    util.setCurrentPath(this, this.$route.name as string);
  }
  mounted() {
    this.init();
  }
  async created() {
    this.$store.commit("app/setOpenedList");
    this.checkDocument(this.$router.currentRoute.path)
    // // 获取用户头像信息
    // if (!this.$store.state.userDetail.avatar) {
    //   await this.$store.dispatch({
    //     type: 'userDetail/init'
    //   })
    // }
    // this.avatar = this.$store.state.userDetail.avatar
  }
  @Watch('$route') 
  routechange(to:any, from:any) {
    this.checkDocument(to.path)
  }
  checkDocument(path: string) {
    switch (path) {
      // TODO: 流程中心文档分类
      case '/customerManage/tbgl':  // 投标管理
      case '/customerManage/purchaserVisitList':  // 采购人拜访记录
      case '/customerManage/purchaserArchives':  // 采购人档案
      case '/customerManage/npform':  // 项目立项
      case '/documentation/documenting':  // 编制及挂网
      case '/nprojecttable/examineEnroll':  // 报名审核
      case '/documentation/documenting':  // 编制及挂网
      case '/depositMenu/receiveDeposit':  // 领取保证金
      case '/depositMenu/depositProject':  // 领取保证金（广发）
      case '/projectCenter/cancelProject':  // 项目取消
      case '/dzpbhw/kbrl':  // 开标日历表
      case '/dzpbhw/evaluationBid':  // 电子评标
      case '/projectCenter/biddingConfirm':  // 中标确认
      case '/projectCenter/documentSummary':  // 文件汇总
      case '/depositMenu/depositBackMenu':  // 退保申请
      case '/projectCenter/projectModify':  // 项目编辑
      case '/projectCenter/endingProject':  // 历史项目
      case '/documentation/npform2':  // 立项确认
      case '/depositMenu/depositDetail':  // 保证金明细
      case '/financeManager/expertFee':  // 专家费借支
      case '/financeManager/expertFeeArgu':  // 专家费借支（其他）
      case '/dzpbhw/room':  // 会议室（非开标）
      case '/commission/commissionRule':  // 提成系统
      case '/financeManager/onlineCharge':  // 线上服务费
        this.hasDocument = true
      break
      default: this.hasDocument = false
    }
  }
  helpDocument() {
    let url = 'http://www.chinapsp.cn'
    axios.get(url + `/api/v1/stl/channels?apiKey=${apiKey}&siteId=2139&channelIndex=help`).then(
      async(res) => {
        let i = 0, data = res.data.value, document = []
        for (i = 0; i < data.length; i++) {
          let rep = await axios.post(url + `/api/v1/contents?apiKey=${apiKey}`, {
            siteId: data[i].siteId,
            channelId: data[i].id,
            orders: 'addDate DESC'
          })
          if (rep.data.contents.length > 0) document = rep.data.contents.filter((item:any) => item.summary === this.$router.currentRoute.path )
          if (document.length > 0) break
        }
        if(document.length > 0 && document[0].content != '') {
          this.document = document[0]
          // 图片格式
          let arr = this.document.content.match(/<img(.*?)src="(.*?)"(.*?)\/>/g)
          if (arr != null) {
            arr.forEach((item:any,index:number) => {
              this.document.content = this.document.content.replace(item,item.slice(0,10) + url + item.slice(10))
            })
          }
          this.showDocument = true
        } else {
          this.$Message.info('当前页面说明文档正在拼命撰写中...')
        }
      }
    )
  }
}
